import { createFileRoute } from '@tanstack/react-router';
import { AddressBookPage } from '@/features/client/address-book';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/address-book/')({
  beforeLoad: clientGuard,
  component: AddressBookIndexRoute,
});

function AddressBookIndexRoute() {
  return <AddressBookPage />;
}
